export default __webpack_public_path__ + "static/news2-13b58db155ff8767bd00a4281c78c58b.webp";